import React, { useEffect } from 'react';
import { Alert } from '@mui/material';
import { DeliveryDestination, DeliveryInformationData, DeliveryProvider } from '../Rest/Services/UserService/Data';
import './SelfPickupFields.css';

interface SelfPickupFieldsProps {
  value: DeliveryInformationData;
  onChange: (next: DeliveryInformationData) => void;
}

function SelfPickupFields({ value, onChange }: SelfPickupFieldsProps) {
  useEffect(() => {
    if (
      value.provider === DeliveryProvider.Self &&
      (value.destination !== DeliveryDestination.Address ||
        value.city ||
        value.number ||
        value.displayName !== 'Самовивіз')
    ) {
      onChange({
        ...value,
        destination: DeliveryDestination.Address,
        city: '',
        number: '',
        displayName: 'Самовивіз',
      });
    }
  }, [onChange, value]);

  return (
    <Alert severity="info" className="self-pickup-note">
      Самовивіз без адреси доставки. Ми узгодимо деталі після оформлення.
    </Alert>
  );
}

export default SelfPickupFields;
